import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FreudButtonModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { AboutZenofficeComponent } from './components/about-zenoffice/about-zenoffice.component';
import { ChoosePlanComponent } from './components/choose-plan/choose-plan.component';
import { SubscriptionDataComponent } from './components/subscription-data/subscription-data.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { PasswordValidationComponent } from './shared/password-validation/password-validation.component';
import { StepsHeaderComponent } from './shared/steps-header/steps-header.component';
import { WizardNavigationComponent } from './shared/wizard-navigation/wizard-navigation.component';
import { SignupComponent } from './signup.component';

@NgModule({
	declarations: [
		SignupComponent,
		WelcomeComponent,
		StepsHeaderComponent,
		AboutZenofficeComponent,
		WizardNavigationComponent,
		ChoosePlanComponent,
		PasswordValidationComponent,
		SubscriptionDataComponent,
	],
	imports: [
		CommonModule,
		TranslateModule,
		FreudButtonModule,
		FormsModule,
		ReactiveFormsModule,
	],
	exports: [
		SignupComponent,
		WelcomeComponent,
		StepsHeaderComponent,
		AboutZenofficeComponent,
		WizardNavigationComponent,
		SubscriptionDataComponent,
		PasswordValidationComponent,
	],
})
export class SignupModule {}
